$(document).ready(function() {
    const mainSwiper = new Swiper('.main-slider', {
        speed: 300,
        
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
            clickable: true,
        },
        
    });

});